import React from "react";

export interface IFlexProps {
  justify?: string;
  align?: string;
  inline?: boolean;
  column?: boolean;
  wrap?: boolean;
  className?: string;
  children: any;
}

const Flex: React.FC<IFlexProps> = ({
  justify,
  align,
  inline,
  column,
  wrap,
  className,
  children,
  ...rest
}) => {
  let classNames = className ?? "";
  classNames += !inline ? " d-flex " : "";
  classNames += inline ? "d-inline-flex " : "";
  classNames += `justify-content-${justify ?? "start"} `;
  classNames += `align-items-${align ?? "start"} `;
  classNames += column ? "flex-column " : "";
  classNames += wrap ? "flex-wrap " : "";
  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  );
};

export default Flex;
